module.exports = __webpack_public_path__ + "4a9802cc13cc06ee992d192ddb09008c.png";